import React from 'react'
import { ListPanel } from '@sukiai/components'
import { useMediaQuery } from 'react-responsive'
import { RESPONSIVE } from '../../lib/constants'
import { getListPanelMarginProps } from '../../lib/helpers'

const ScheduleContainer = ({
  type,
  title,
  dateString,
  day,
  changeDate,
  loading,
  count,
  appointments,
  handleApptClick,
  lastApptOpened,
  openNoteTypeSelection,
  calcheight,
  togglePicker,
  handleModeChange,
  showFullTabs,
  children
}) => {
  const isSmallWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.SMALL_LIST_PANEL_WIDTH}`
  })

  const isCrampedWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.CRAMPED_LIST_PANEL_WIDTH})`
  })

  const marginProps = getListPanelMarginProps()

  return (
    <ListPanel
      type={type}
      title={title}
      dateString={dateString}
      day={day}
      changeDate={changeDate}
      loading={loading}
      count={count}
      appointments={appointments}
      handleApptClick={handleApptClick}
      lastApptOpened={lastApptOpened}
      openNoteTypeSelection={openNoteTypeSelection}
      calcheight={calcheight}
      togglePicker={togglePicker}
      handleModeChange={handleModeChange}
      showFullTabs={showFullTabs}
      isSmallWindow={isSmallWindow}
      isCrampedWindow={isCrampedWindow}
      {...marginProps}
    >
      {children}
    </ListPanel>
  )
}

export default ScheduleContainer
